import { NavLink } from 'react-router'
import getRouteDisabled from '../../animation/get-route-disabled'
import { getRoute } from '../../menu-constants'
import { trackAnalyticsEvent } from '../../../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const DefaultListContent = ({ informations }) => {
  const { t } = useTranslation()
  return (
    <>
      <span
        className={`${
          informations?.navigationMenuInformation.iconIsFilled
            ? 'material-icons notranslate'
            : 'material-icons-outlined notranslate'
        }`}
      >
        {informations?.navigationMenuInformation.iconName}
      </span>
      <span>{informations?.name && t(informations.name)}</span>
    </>
  )
}

const DefaultList = ({ selectedView }) => {
  return (
    <>
      {selectedView?.route.map(link => {
        const informations = getRoute(link.label)
        const isDisabledLink = getRouteDisabled(informations?.id)
        const className = `mg-menu-configuration-links__url ${isDisabledLink ? 'disabled' : ''}`
        return isDisabledLink ? (
          <div key={link.label} className={className}>
            <DefaultListContent informations={informations} />
          </div>
        ) : (
          <NavLink
            key={link.label}
            to={informations?.path}
            className={className}
            onClick={() => {
              trackAnalyticsEvent(`click_top_burger_menu_${informations?.googleAnalyticsAction}`)
            }}
          >
            <DefaultListContent informations={informations} />
          </NavLink>
        )
      })}
    </>
  )
}

export default DefaultList
